import { render } from "./Beneficiary.vue?vue&type=template&id=d62a9644&scoped=true&ts=true"
import script from "./Beneficiary.vue?vue&type=script&lang=ts"
export * from "./Beneficiary.vue?vue&type=script&lang=ts"

import "./Beneficiary.vue?vue&type=style&index=0&id=d62a9644&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d62a9644"]])

export default __exports__